import styled, {css} from 'styled-components'

export const StyledWorkAreasWrapper = styled.div(
    ({theme: {spacing}}) => css`
        position: relative;
        display: flex;
        align-items: center;
        gap: ${spacing}px;
        width: 100%;
        min-width: 0;
        overflow: hidden;

        /* Badges never wrap or shrink: whatever does not fit is folded into the "+N" badge */
        & > * {
            flex-shrink: 0;
            white-space: nowrap;
        }
    `
)

/* Off-screen twin of the visible row used to measure every badge (and the "+N" one) at its natural width */
export const StyledWorkAreasMeasureRow = styled(StyledWorkAreasWrapper)`
    position: absolute;
    top: 0;
    left: 0;
    width: max-content;
    visibility: hidden;
    pointer-events: none;
`

export const StyledOverflowBadgeTrigger = styled.span`
    display: inline-flex;
    flex-shrink: 0;
`
